import { GAME_MODE_RANKS, RANKS } from "@/game-csgo/constants.mjs";

export const GAME_TYPES = {
  COMPETITIVE: 1,
  DANGER_ZONE: 2,
};

const DZ_RANKS = RANKS[GAME_MODE_RANKS.DANGER_ZONE];
const { SPRINTING_HARE_2_IDX, HUNTER_FOX_ELITE_IDX, HOWLING_ALPHA_IDX } =
  DZ_RANKS.reduce(
    (acc, cur, idx) => {
      const i = cur.name;
      if (i === "Sprinting Hare II") acc.SPRINTING_HARE_2_IDX = idx;
      if (i === "Hunter Fox Elite") acc.HUNTER_FOX_ELITE_IDX = idx;
      if (i === "The Howling Alpha") acc.HOWLING_ALPHA_IDX = idx;
      return acc;
    },
    {
      SPRINTING_HARE_2_IDX: 0,
      HUNTER_FOX_ELITE_IDX: 0,
      HOWLING_ALPHA_IDX: 0,
    },
  );
const DANGER_ZONE_RANKS = {
  SPRINTING_HARE_2: SPRINTING_HARE_2_IDX,
  HUNTER_FOX_ELITE: HUNTER_FOX_ELITE_IDX,
  HOWLING_ALPHA: HOWLING_ALPHA_IDX,
};
const DANGER_ZONE_COLORS = {
  BLUE: {
    fill: "#B7D7E3",
    text: "#B7D7E3",
    gradiant: {
      start: "#B7D7E3",
      end: "#B7D7E3",
    },
  },
  YELLOW: {
    fill: "#E1BE54",
    text: "#E1BE54",
    gradiant: {
      start: "#E1BE54",
      end: "#E1BE54",
    },
  },
  ORANGE: {
    fill: "#FD8F29",
    text: "#FD8F29",
    gradiant: {
      start: "#FD8F29",
      end: "#FD8F29",
    },
  },
};

export const deathMatchColors = {
  1: "var(--yellow)",
  2: "#A6ACB9",
  3: "#AE8967",
  4: "var(--shade2)",
};

const DEFAULT_COLORS = {
  fill: "var(--shade6)",
  text: "var(--shade3)",
  gradiant: {
    start: "var(--shade5)",
    end: "var(--shade6)",
  },
};

export default (gameType, rank) => {
  if (typeof rank !== "number") return DEFAULT_COLORS;
  // Competitive and Wingman colors
  if (gameType === GAME_TYPES.COMPETITIVE) {
    if (rank >= 0 && rank <= 6) {
      return {
        fill: "#B7D7E3",
        text: "#B7D7E3",
        gradiant: {
          start: "#B7D7E3",
          end: "#B7D7E3",
        },
      };
    } else if (rank > 6 && rank <= 10) {
      return {
        fill: "#E1BE54",
        text: "#E1BE54",
        gradiant: {
          start: "#E1BE54",
          end: "#E1BE54",
        },
      };
    }
    return {
      fill: "#FDA829",
      text: "#FDA829",
      gradiant: {
        start: "#FDA829",
        end: "#FDA829",
      },
    };
  }
  // Danger zone colors
  if (gameType === GAME_TYPES.DANGER_ZONE) {
    switch (true) {
      case rank > 0 && rank <= DANGER_ZONE_RANKS.SPRINTING_HARE_2:
        return DANGER_ZONE_COLORS.YELLOW;
      case rank > DANGER_ZONE_RANKS.SPRINTING_HARE_2 &&
        rank <= DANGER_ZONE_RANKS.HUNTER_FOX_ELITE:
        return DANGER_ZONE_COLORS.ORANGE;
      default:
        return DANGER_ZONE_COLORS.BLUE;
    }
  }
  // Non-ranked colors
  if (rank > 0 && rank <= 6) {
    return {
      fill: "#BDBEC1",
      text: "#BDBEC1",
      gradiant: {
        start: "#BDBEC1",
        end: "#BDBEC1",
      },
    };
  } else if (rank > 6 && rank <= 10) {
    return {
      fill: "#80A6FF",
      text: "#80A6FF",
      gradiant: {
        start: "#80A6FF",
        end: "#80A6FF",
      },
    };
  }
  return DEFAULT_COLORS;
};
